import type { IAccordionCardProps } from "./AccordionCard";
import { AccordionCard } from "./AccordionCard";
import { StatusWithBorder } from "../Status/Status";
import { useTranslation } from "react-i18next";
import { ProductStatusType } from "../../types/types.PIM";
import styled from "styled-components";
import { TitleSpan } from "../Typography/Typography";

const AccordionWrapper = styled.div`
  > div > div > div > div:first-child {
    transform: rotate(-90deg) !important;
    transition: all 0.2s ease-out;
  }

  > div:has(.accordion-content-wrapper) > div > div > div:first-child {
    transform: rotate(0deg) !important;
  }
`;

export const AccordionCardWithStatus = (
  props: Omit<IAccordionCardProps, "actionChildren"> & {
    status?: string;
  }
) => {
  const { t } = useTranslation();
  const { status, title, ...restProps } = props;

  const titleWithStatus = () => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <TitleSpan>{typeof title === "string" ? title : title()}</TitleSpan>
      {status && (
        <StatusWithBorder status={status as ProductStatusType} t={t} />
      )}
    </div>
  );

  return (
    <AccordionWrapper>
      <AccordionCard
        {...restProps}
        title={titleWithStatus}
        actionChildren={() => <></>}
        expanded={false}
        hideHeaderBorder={true}
      >
        {props.children}
      </AccordionCard>
    </AccordionWrapper>
  );
};
